const React = require('react');

class Notifier extends React.Component {
  
  static focus = (title, context, url, icon, name) => {
    if (!('Notification' in window)) {
      console.log("Your browser does not support desktop notifications, please try Chrome or Firefox.");
      return false;
    }
    
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    } else {
      icon = (icon && icon.match(/^.*\.(jpeg|jpg|gif|png)/gi)) ? icon : "http://ob9oayzh3.bkt.clouddn.com/images.png"
      let notification = new Notification(title, {
        icon: icon,
        body: context,
        tag: (title + context)
      });
      notification.onclick = function () {
        if (url) {
          window.open(url, name);
        } else {
          window.parent.focus();
          window.focus();
          this.close();
        }
      };
    }
  }
  
  shouldComponentUpdate() {
    return false;
  }
  
  getScript = () => {
    return 'document.addEventListener("DOMContentLoaded", function () { if (Notification.permission !== "granted") Notification.requestPermission(); });';
  }
  
  render() {
    return React.createElement("script", {
      type: "text/javascript",
      dangerouslySetInnerHTML: {
        __html: this.getScript()
      }
    });
  }
  
  
}

module.exports = Notifier;



// WEBPACK FOOTER //
// ./src/utils/notification.js